/** Podstrony (CMS landing pages) */
import Layout from '@/layout';

const cmsPagesRoutes = {
  path: '/cms-pages',
  component: Layout,
  redirect: '/cms-pages/list',
  name: 'CmsPages',
  alwaysShow: true,
  meta: {
    title: 'Podstrony',
    icon: 'el-icon-document-copy',
    permissions: ['list cms page'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/cms-pages/List'),
      name: 'CmsPagesList',
      meta: { title: 'Lista podstron', noCache: true, icon: 'el-icon-tickets', permissions: ['list cms page'] },
    },
    {
      path: 'add',
      component: () => import('@/views/cms-pages/AddPage'),
      name: 'CmsPagesAdd',
      meta: { title: 'Dodaj podstronę', noCache: true, icon: 'el-icon-plus', permissions: ['add cms page'] },
    },
    {
      path: 'edit/:id',
      component: () => import('@/views/cms-pages/EditPage'),
      name: 'CmsPagesEdit',
      hidden: true,
      meta: { title: 'Edytuj podstronę', noCache: true, permissions: ['update cms page'] },
    },
  ],
};

export default cmsPagesRoutes;
